import { signal } from 'services/SignalsService'
import { StoreageService } from 'services/StoreageService'

export default class AutoLimitModel {
  constructor() {
    this._ids = {}
    this._limits = {
      win: [],
      loss: [],
    }
    this.filters = ['win', 'loss']
    this.filters.forEach((item) => this.makeModel(item))
    this.isAuto = false
    signal.on('STATE:IN:AUTO', () => this.isAuto = true)
    signal.on('STATE:OUT:AUTO', () => this.isAuto = false)
  }

  makeModel(type) {
    const self = this
    signal.on(`RADIO:${type}`, function (value) {
      self._ids[type] = parseInt(value)
      StoreageService.set(type,  self._ids[type])
    })
  }

  getAutoLimits(type) {
    return this._limits[type]
  }

  getType(type) {
    return (this._limits[type][this._ids[type]]) * game.models.BetModel.getValue()
  }

  getIDLoss() {
    return this._ids.loss
  }

  getIDWin() {
    return this._ids.win
  }

  setAutoLimits(value) {
    for (const key in value) {
      value[key].forEach((item, index) => item == null && (value[key][index] = Number.POSITIVE_INFINITY))
    }
    this._limits = value
  }
}
